export const APP_NAME = "NPPL ESPORTS";
export const APP_TAGLINE = "Play Multiple Games & Earn Cash Rewards";
export const ORGANISATION = "NPPL ESPORTS";

//also edit in functions
export const DB = {
    name: 'tournifycms',
    TOURNAMENTS: "wTournaments",
    TEAMS: "wTeams",
    REGISTRATION_FORMS: "wRegistrationForms",
    RESPONSES: "wResponses",
    MATCHES: "wMatches",
    PUBLIC_POSTS: "wPublicPosts",
    ADMINS: 'wAdmins'
}

export const STORAGE = {
   TOURNAMENTS: "wTournaments",
   TOURNAMENT_LOGO: "logo.webp",
   TOURNAMENT_LOGO_META: {
        cacheControl: 'public,max-age=300'
   },
   TOURNAMENT_BANNER: "banner.webp",
   TOURNAMENT_BANNER_META: {
        cacheControl: 'public,max-age=300'
   },
   TEAMS: "wTeams",
   TEAM_LOGO: "logo.webp",
   TEAM_IMAGE_META: {
        cacheControl: 'public,max-age=300'
   },
   MEDIA: "wMedia",
   MEDIA_META : {
        cacheControl: 'public,max-age=300'
   }
}


export const STORAGE_REF = {
    getTourneyRef: (id)=> STORAGE.TOURNAMENTS+'/'+id,
    getTeamRef: (id,teamId) => STORAGE.TOURNAMENTS+'/'+id+'/'+STORAGE.TEAMS+'/'+teamId,
    getPlayerImageName: (i) => "player"+i+".webp",
    getMediaRef: () => STORAGE.MEDIA
}